const $csrfToken = document.querySelector('[name=csrf-token]')
export const csrfToken = $csrfToken ? $csrfToken.content : null;

export const fetchAPI = async (url, options) => {
    const config = {
        headers: {
            'X-CSRFTOKEN': csrfToken,
            'Content-Type': 'application/json',
        },
        ...options
    };
    const response = await fetch(`/api${url}`, config);
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return await response.json();
    }
    return await response.text();
}